import { NgbDateStruct, NgbTimeStruct} from '@ng-bootstrap/ng-bootstrap';

export class DateUtilities {

    /**
     *
     * @param fromDateInput from date
     * @param toDateInput to date
     * @param undefiendDatesAreValid true if undefined dates are valid
     * @returns
     */
    public static isDateRangeValid(fromDateInput, toDateInput, undefinedDatesAreValid: boolean): boolean {
        if (fromDateInput && toDateInput) {
            let fromDate = new Date(fromDateInput.year, fromDateInput.month - 1, fromDateInput.day);
            let toDate = new Date(toDateInput.year, toDateInput.month - 1, toDateInput.day);

            return (fromDate <= toDate);
        }

        return undefinedDatesAreValid;
    }


/**
 * @param fieldName the field that will be included in the query string
 * @param fromDate the from date
 * @param toDate the to date
 * @returns a strinng representing a search in lucene format
 */
    public static getDateRangeQuery(fieldName: String, fromDate: NgbDateStruct, toDate: NgbDateStruct): string {
        let fromDateTerm: String;
        let toDateTerm: String;

        if (fromDate) {
            let fromMonth: number = fromDate.month;
            let fromDay: number = fromDate.day;
            fromDateTerm = fromDate.year + '-'
                + (fromMonth < 10 ? '0' + fromMonth : fromMonth)
                + '-' + (fromDay < 10 ? '0' + fromDay : fromDay);
        } else {
            fromDateTerm = '*';
        }

        if (toDate) {
            let realToDate = new Date(toDate.year, toDate.month - 1, toDate.day);
            realToDate.setDate(realToDate.getDate());
            let toDay = realToDate.getDate();
            let toMonth = realToDate.getMonth() + 1 ;
            toDateTerm = realToDate.getFullYear() + '-'
                + (toMonth < 10 ? '0' + toMonth : toMonth )
                + '-'  + (toDay < 10 ? '0' + toDay : toDay);
        } else {
            toDateTerm = '*';
        }

        return fieldName + ':[ ' + fromDateTerm + ' TO ' + toDateTerm + ']';
    }

    public static toDateStruct (date: Date): NgbDateStruct {
        if ( date ) {
            return {
                year: date.getFullYear(),
                month: date.getMonth() + 1,
                day: date.getDate()
            };
        } else {
            let today: Date = new Date();
            return {
                year: today.getFullYear(),
                month: today.getMonth() + 1,
                day: today.getDate()
            };
        }
    }

    public static isNgbDateStruct(obj: any): obj is NgbDateStruct {
        return (
            obj &&
            typeof obj.year === 'number' &&
            typeof obj.month === 'number' &&
            typeof obj.day === 'number'
        );
    }

    public static toTimeStruct(date: Date): NgbTimeStruct {
        if ( date ) {
            return {
                hour: date.getHours(),
                minute : date.getMinutes(),
                second : date.getSeconds()
            };
        } else {
            let now = new Date();
            return {
                hour: now.getHours(),
                minute : now.getMinutes(),
                second : now.getSeconds()
            };
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/date/date-utils.ts